import { createReducer, on } from '@ngrx/store';
import { Ratio } from '../../models/ratio.model';
import * as RatiosActions from './ratios.actions';

export interface RatiosState {
  ratios: Ratio[];
  selectedRatio: Ratio | null;
  loading: boolean;
  error: any;
}

export const initialState: RatiosState = {
  ratios: [],
  selectedRatio: null,
  loading: false,
  error: null,
};

export const ratiosReducer = createReducer(
  initialState,

  // Load Ratios
  on(RatiosActions.loadRatios, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(RatiosActions.loadRatiosSuccess, (state, { ratios }) => ({
    ...state,
    ratios,
    loading: false,
    error: null,
  })),
  on(RatiosActions.loadRatiosFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Single Ratio
  on(RatiosActions.loadRatio, (state) => ({
    ...state,
    selectedRatio: state.selectedRatio,
    loading: true,
    error: null,
  })),

  on(RatiosActions.loadRatioSuccess, (state, { ratio }) => ({
    ...state,
    selectedRatio: ratio,
    loading: false,
    error: null,
  })),
  on(RatiosActions.loadRatioFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Create Ratio
  on(RatiosActions.createRatio, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(RatiosActions.createRatioSuccess, (state, { ratio }) => ({
    ...state,
    loading: false,
    error: null,
  })),
  on(RatiosActions.createRatioFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update Ratio
  on(RatiosActions.updateRatio, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(RatiosActions.updateRatioSuccess, (state, { ratio }) => ({
    ...state,
    selectedRatio: ratio,
    loading: false,
    error: null,
  })),
  on(RatiosActions.updateRatioFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Delete Ratio
  on(RatiosActions.deleteRatio, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(RatiosActions.deleteRatioSuccess, (state, { id }) => ({
    ...state,
    ratios: state.ratios.filter((ratio) => ratio.id !== id),
    loading: false,
    error: null,
  })),
  on(RatiosActions.deleteRatioFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
